export default {
  title: "The Team",
  text: "The founding team share love for art, tech, music and the digital world. Frenzs forever, with common interests and ambitions, sharing a unique set of skills and connections, are finally joining forces to moon Shamanzs, turning it into a long lasting brand. ",
};
